import axios from "axios";
import { getConfig } from "../../../ApiHelpers/ApiDefaultConfig";
import { CreatePromotionRequest, DeletePromotionsResponse, Promotion, PromotionsResponse } from "./models";

const getPromotions = async (): Promise<PromotionsResponse> => {
    let config = getConfig();
    try {
        const response = await axios.get<PromotionsResponse>(`/admin/promotions`, config);
        return response.data;

    } catch (error) {
        return error as any;
    }
};

const updatePromotion = async (promotion: Promotion): Promise<PromotionsResponse> => {
    let config = getConfig();
    try {
        const response = await axios.patch(`/admin/promotions/${promotion.id}`, promotion, config);
        return response.data;
    } catch (error) {
        return error as any;
    }
};

const createPromotion = async (promotion: CreatePromotionRequest): Promise<PromotionsResponse> => {
    let config = getConfig();
    try {
        const response = await axios.post(`/admin/promotions`, promotion, config);
        return response.data;
    } catch (error) {
        return error as any;
    }
};

const deletePromotion = async (promotionId: string): Promise<DeletePromotionsResponse> => {
    let config = getConfig();
    try {
        const response = await axios.delete(`/admin/promotions/${promotionId}`, config);
        return response.data;
    } catch (error) {
        return error as any;    
    }
};

const togglePromotion = async (promotionId: string): Promise<any> => {
    let config = getConfig();
    try {
        const response = await axios.patch(`/admin/promotions/toggle-active/${promotionId}`, {}, config);
        return response.data;
    } catch (error) {
        return error as any;
    }
};


export { getPromotions, updatePromotion, createPromotion, deletePromotion, togglePromotion };